<script>
	import { fly, fade } from "svelte/transition";
	import {
		lang,
		familySize,
		income,
		incomeLimit,
		servicePayPercentages,
	} from "../store";
	import { formatCurrency } from "../lib/utils";

	let hours;
	let minutes;
	let monthlyCost = 0;
	const servicePayHourKeys = Object.keys($servicePayPercentages);
	let maxHours = Math.max(...servicePayHourKeys);

	$: if (minutes >= 60) {
		hours += 1;
		minutes = 0;
	}

	$: incomeOverLimit = Math.max(0, $income - $incomeLimit);
	$: totalHours = ((hours * 60 + minutes) / 60);
	$: totalMonthlyHours = Math.min(
		maxHours,
		Math.round((totalHours / 7) * 30.42)
	);
	$: if (totalMonthlyHours) {
		monthlyCost =
			incomeOverLimit *
			($servicePayPercentages[totalMonthlyHours][$familySize] / 100);
	} else {
		monthlyCost = 0;
	}

	function handleChange() {
		hours = hours ? hours : 0;
		minutes = minutes ? minutes : 0;
	}
</script>

<fieldset>
	<legend class="psl-label">Palvelutunnit viikossa:</legend>
	<div class="psl-container">
		<div class="input-wrapper input-wrapper--hours">
			<label class="screen-reader-text" for="municipality-hours-input"
				>Tunnit</label
			>
			<input
				id="municipality-hours-input"
				class="psl-input hours"
				type="number"
				step="1"
				min="0"
				max="168"
				bind:value={hours}
				placeholder={0}
				on:change={handleChange}
			/>
		</div>
		<div class="input-wrapper input-wrapper--minutes">
			<label class="screen-reader-text" for="municipality-minutes-input"
				>Minuutit</label
			>
			<input
				id="municipality-minutes-input"
				class="psl-input minutes"
				type="number"
				step="10"
				min="0"
				max="60"
				bind:value={minutes}
				placeholder={0}
				on:change={handleChange}
			/>
		</div>
	</div>
</fieldset>

{#if monthlyCost}
	<div
		class="costs-container"
		in:fly={{ y: -20 }}
		out:fade={{ duration: 200 }}
	>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path
				d="M512 80C512 98.01 497.7 114.6 473.6 128C444.5 144.1 401.2 155.5 351.3 158.9C347.7 157.2 343.9 155.5 340.1 153.9C300.6 137.4 248.2 128 192 128C183.7 128 175.6 128.2 167.5 128.6L166.4 128C142.3 114.6 128 98.01 128 80C128 35.82 213.1 0 320 0C426 0 512 35.82 512 80V80zM160.7 161.1C170.9 160.4 181.3 160 192 160C254.2 160 309.4 172.3 344.5 191.4C369.3 204.9 384 221.7 384 240C384 243.1 383.3 247.9 381.9 251.7C377.3 264.9 364.1 277 346.9 287.3C346.9 287.3 346.9 287.3 346.9 287.3C346.8 287.3 346.6 287.4 346.5 287.5L346.5 287.5C346.2 287.7 345.9 287.8 345.6 288C310.6 307.4 254.8 320 192 320C132.4 320 79.06 308.7 43.84 290.9C41.97 289.9 40.15 288.1 38.39 288C14.28 274.6 0 258 0 240C0 205.2 53.43 175.5 128 164.6C138.5 163 149.4 161.8 160.7 161.1L160.7 161.1zM391.9 186.6C420.2 182.2 446.1 175.2 468.1 166.1C484.4 159.3 499.5 150.9 512 140.6V176C512 195.3 495.5 213.1 468.2 226.9C453.5 234.3 435.8 240.5 415.8 245.3C415.9 243.6 416 241.8 416 240C416 218.1 405.4 200.1 391.9 186.6V186.6zM384 336C384 354 369.7 370.6 345.6 384C343.8 384.1 342 385.9 340.2 386.9C304.9 404.7 251.6 416 192 416C129.2 416 73.42 403.4 38.39 384C14.28 370.6 .0003 354 .0003 336V300.6C12.45 310.9 27.62 319.3 43.93 326.1C83.44 342.6 135.8 352 192 352C248.2 352 300.6 342.6 340.1 326.1C347.9 322.9 355.4 319.2 362.5 315.2C368.6 311.8 374.3 308 379.7 304C381.2 302.9 382.6 301.7 384 300.6L384 336zM416 278.1C434.1 273.1 452.5 268.6 468.1 262.1C484.4 255.3 499.5 246.9 512 236.6V272C512 282.5 507 293 497.1 302.9C480.8 319.2 452.1 332.6 415.8 341.3C415.9 339.6 416 337.8 416 336V278.1zM192 448C248.2 448 300.6 438.6 340.1 422.1C356.4 415.3 371.5 406.9 384 396.6V432C384 476.2 298 512 192 512C85.96 512 .0003 476.2 .0003 432V396.6C12.45 406.9 27.62 415.3 43.93 422.1C83.44 438.6 135.8 448 192 448z"
			/>
		</svg>
		<p>
			Asiakasmaksu viikossa:
			<span class="value">
				{formatCurrency((monthlyCost / 30.42) * 7, $lang)}
			</span>
		</p>
		<p>
			Asiakasmaksu kuukaudessa:
			<span class="value">
				{formatCurrency(monthlyCost, $lang)}
			</span>
		</p>
	</div>
{/if}

<style>
	.psl-container {
		display: flex;
	}

	fieldset {
		margin: 0;
		padding: 0;
		border: 0;
	}

	.hours {
		width: 100%;
		border-radius: var(--border-radius-small);
	}

	.minutes {
		width: 100%;
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
		border-left: 0;
		padding-right: 4rem;
	}

	.input-wrapper {
		position: relative;
		width: 100%;
	}

	.input-wrapper--minutes {
		display: none;
	}

	.input-wrapper:after {
		font-size: 1rem;
		font-weight: 500;
		position: absolute;
		right: 2px;
		top: 2px;
		z-index: 1;
		height: calc(100% - 4px);
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
		border-left: 2px solid var(--color-blue);
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--color-gray);
	}

	.input-wrapper--hours:after {
		content: "h";
		width: 2.5rem;
	}

	.input-wrapper--minutes:after {
		content: "min";
		width: 3rem;
	}

	@media (min-width: 600px) {
		.hours {
			border-radius: var(--border-radius-small) 0 0
				var(--border-radius-small);
			padding-right: 3.5rem;
		}

		.input-wrapper--minutes {
			display: block;
		}

		.input-wrapper--hours:after {
			content: "h";
			width: 2.5rem;
		}
	}

	.costs-container {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		margin-top: 1rem;
		padding: 1rem;
		background-color: var(--color-blue);
		color: var(--color-gray);
		border-radius: var(--border-radius-small);
		line-height: 1.3;
	}

	svg {
		display: none;
		width: 54px;
		height: 54px;
		fill: var(--color-gray);
		opacity: 0.5;
	}

	p {
		margin: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.value {
		font-size: 2rem;
		color: var(--color-yellow);
		font-weight: 500;
	}

	@media (min-width: 600px) {
		.costs-container {
			flex-direction: row;
		}

		svg {
			display: block;
		}
	}
</style>
